document.addEventListener('turbolinks:load', function () {
    // .teams.create needed too: a #create validation failure re-renders "new" via `render :new`, which keeps the "teams create" body class, not "teams new".
    if ($('.teams.show, .invitations.new, .invitations.create, .teams.new, .teams.create, .teams.edit').length === 0) {
        return false
    }

    let applyAllSwitch = $('.permission-access .apply-all')
    let selectAllSwitch = $('.permission-access .permission-wrapper .select-all')
    let permissionCheckbox = $(".permission-access .permission-wrapper .access-checkboxes input[type='checkbox']")

    // select all permissions by each module
    $(selectAllSwitch).on('change', function () {
        let moduleType = $(this).data('moduleType')
        if ($(this).prop('checked') === true) {
            $('.' + moduleType).prop('checked', true);
            tickApplyAll()
        } else {
            $('.' + moduleType).prop('checked', false);
            unTickApplyAll()
        }
    });

    // apply all permissions on all module
    $(applyAllSwitch).on('change', function () {
        if ($(this).prop('checked') === true) {
            $(".permission-wrapper input[type='checkbox']").prop('checked', true);
        } else {
            $(".permission-wrapper input[type='checkbox']").prop('checked', false);
        }
    });

    // uncheck select all and apply all when at least one permission is unchecked
    $(permissionCheckbox).on('change', function () {
        if ($(this).prop('checked') === true) {
            tickSelectAll($(this))
        } else {
            unTickSelectAll($(this))
        }
    });

    // tick select all for the module if all the checkboxes inside it are selected
    function tickSelectAll(checkbox) {
        let accessActionSection = $(checkbox).parents('.access-action-section');
        let checkboxesCount = $(accessActionSection).find("input:checkbox").length
        let checkedCheckboxesCount = $(accessActionSection).find("input:checkbox:checked").length
        if (checkedCheckboxesCount === checkboxesCount) {
            let permissionWrapper = $(checkbox).parents('.permission-wrapper');
            let selectAll = $(permissionWrapper).find('.select-all')
            $(selectAll).prop('checked', true)
            tickApplyAll()
        }
    }

    // unselect all for the module if all the checkboxes inside it are selected
    function unTickSelectAll(checkbox) {
        let permissionWrapper = $(checkbox).parents('.permission-wrapper');
        let selectAll = $(permissionWrapper).find('.select-all')
        $(selectAll).prop('checked', false)
        unTickApplyAll()
    }

    // tick apply all if all the permissions are selected
    function tickApplyAll() {
        let selectAllSwitchCount = $(selectAllSwitch).length
        let tickedSelectAllSwitchCount = $('.permission-access .permission-wrapper .select-all:checked').length
        if (selectAllSwitchCount === tickedSelectAllSwitchCount) {
            $(applyAllSwitch).prop('checked', true)
        }
    }

    // uncheck apply all if at least one permission is not selected
    function unTickApplyAll() {
        $(applyAllSwitch).prop('checked', false)
    }

    if ($('.teams .show').length > 0) {
        $(permissionCheckbox).trigger('change')
    }

    // Function to check all required checkboxes
    function checkRequiredCheckboxes(checkbox) {
        const requires = checkbox.getAttribute('data-requires');
        if (requires) {
            const requiredCheckboxes = requires.split(',').map(req => req.trim());
            requiredCheckboxes.forEach(req => {
                const requiredCheckbox = document.querySelector(`input[type="checkbox"][id="type_${req}"]`);
                if (requiredCheckbox && !requiredCheckbox.checked) {
                    requiredCheckbox.checked = true;

                    tickSelectAll($(requiredCheckbox))
                    // Recursively check any required checkboxes for this one
                    checkRequiredCheckboxes(requiredCheckbox);
                }
            });
        }
    }

    // Uncheck dependents too: the server re-grants requirements of any checked permission, undoing the uncheck
    function uncheckDependentCheckboxes(checkbox) {
        const id = checkbox.id.replace(/^type_/, '');
        document.querySelectorAll('input[type="checkbox"][data-requires]').forEach(dependent => {
            const requires = dependent.getAttribute('data-requires').split(',').map(req => req.trim());
            if (dependent.checked && requires.includes(id)) {
                dependent.checked = false;
                unTickSelectAll($(dependent));
                uncheckDependentCheckboxes(dependent);
            }
        });
    }

    // Native listeners, so the page-load jQuery .trigger('change') doesn't cascade
    document.querySelectorAll('.permission-access .access-checkboxes input[type="checkbox"]').forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            if (this.checked) {
                checkRequiredCheckboxes(this);
            } else {
                uncheckDependentCheckboxes(this);
            }
        });
    });
});